import { ITab } from 'components/common/CustomizedTabs/CustomizedTabs';
import { ITableData } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

import TableTab from 'components/Dashboards/Project/Components/VersionCompare/TableTab/tableTab';
import RecommendationTableTab from 'components/Dashboards/Project/Components/VersionCompare/TableTab/recommendationTableTab';
import { IRecomendationTableDataResponse } from 'components/widgets/Recommendations/queries/useQueryRecommendationTable';

export type TKeys = 'prev' | 'next' | 'all';

export const generateTabs = ({ data }: { data: ITableData }): ITab<TKeys>[] => {
    if (data && data.periodItemsList) {
        const prevData = data.periodItemsList.find((item) => item.id === 'prev');
        const nextData = data.periodItemsList.find((item) => item.id === 'next');
        const allData = data.periodItemsList.find((item) => item.id === 'all');

        if (prevData && nextData && allData) {
            return [
                {
                    value: 'prev',
                    label: <TableTab data={prevData} />,
                },
                {
                    value: 'next',
                    label: <TableTab data={nextData} />,
                },
                {
                    value: 'all',
                    label: <TableTab data={allData} />,
                },
            ];
        }
    }
    return [];
};

//TODO: fix data typing - maybe when separating tableWrapper component

export type TRecommendationTabs = 'all' | 'PROGRESS' | 'RISK' | 'QUALITY';
export const generateRecommendationsTabs = ({
    data,
}: {
    data: IRecomendationTableDataResponse | undefined;
}): ITab<TRecommendationTabs>[] => {
    if (data && data.recommendationResponse) {
        const categories = {
            PROGRESS: 0,
            RISK: 0,
            QUALITY: 0,
            all: data.recommendationResponse.length,
        };

        data.recommendationResponse.forEach((item) => {
            const index = item.category.name;
            if (index) {
                categories[index] = categories[index] + 1;
            }
        });

        return [
            {
                value: 'all',
                label: <RecommendationTableTab title={`All (${categories.all})`} />,
            },
            {
                value: 'PROGRESS',
                label: <RecommendationTableTab title={`Progress (${categories.PROGRESS})`} />,
            },
            {
                value: 'RISK',
                label: <RecommendationTableTab title={`Risk (${categories.RISK})`} />,
            },
            {
                value: 'QUALITY',
                label: <RecommendationTableTab title={`Quality (${categories.QUALITY})`} />,
            },
        ];
    }

    return [];
};

export const arrayBufferToString = (buffer) => String.fromCharCode.apply(null, new Uint8Array(buffer));
